import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

/**
 * AppLayout
 * Wraps all non-auth pages with the shared Navbar.
 * Auth pages (login, signup, etc.) render WITHOUT this layout.
 */
export default function AppLayout() {
  return (
    <div>
      <Navbar />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
